<template>
    <div class="loginbg" style="display: none;" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form @submit.prevent="emailVerify();" id="forgotPassword" name="form">
                            <div class="form-group">
                                <label for="username">Email</label>
                                <input v-model="email" type="text" name="email" class="form-control" id="email" placeholder="Enter Email">
                                <span class="help is-danger">{{emailError}}</span>
                            </div>
                            <div>
                                <label id="errorMsg" class=""></label>
                                <!-- <label id="errorMsg" class="help is-danger"></label><br> -->
                                <!-- <label id="successMsg" class="success text-success"></label><br> -->
                            </div>
                            <div>
                                <button style="margin-top: 3%" :disabled="disableButtons.submitButton" id="loginbtn" type="submit" class="btn btn-primary">{{buttonNames.submitButton}}</button>
                                <router-link class="pull-right" style="text-decoration: underline !important; margin-top: 6%" v-bind:to="{name: 'CustomerLogin'}"> Back to Login</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {customer_login} from '../../config';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    var self;

    export default {
        name: 'UserForgotPassword',
        data() {
            return {
                email: "",
                emailError: "",
                buttonNames : {
                    submitButton : 'Submit',
                },
                disableButtons : {
                    submitButton : false,
                },
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            $('#main-header').hide();
            $('#sidebar-wrapper').hide();
            $("#wrapper").addClass("login-div-full");
            $(".loginbg").show();
            $('#errorMsg,#successMsg').hide();
            var tokenData = self.$route.query.token;
            var emailData = self.$route.query.email;
            if (tokenData != undefined) {
                var fields = {
                    tokenValue: tokenData,
                    username: emailData,
                };
                HTTP.post("/user/check", fields)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                self.$router.push("/user/resetpassword/" + response.data.content);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            }
                        });
            }
        },
        methods: {
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            checkForm: function() {
                var checked = true;
                self.emailError = "";
                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.email && !self.validEmail(self.email)) {
                    self.emailError = "Please Enter Valid Email";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            emailVerify: function() {
                self.checkForm();
                if (self.checkForm()) {
                    $('#errorMsg').html('');
                    $('#successMsg').html('');
                    $('#errorMsg,#successMsg').hide();
                    self.buttonNames.submitButton = "Submiting...";
                    self.disableButtons.submitButton = true;
                    var fields = {
                        username: self.email,
                    };
                    HTTP.post("/user/check", fields)
                            .then(function (response) {
                                self.buttonNames.submitButton = "Submit";
                                self.disableButtons.submitButton = false;
                                if (response.data.status == "success") {
                                    self.disableButtons.submitButton = true;
                                    // $('#successMsg').show();
                                    // $('#successMsg').html(response.data.message);
                                    $("#errorMsg").addClass('success text-success');
                                    $('#errorMsg').show();
                                    $('#errorMsg').html(response.data.message);
                                    setTimeout(function () {
                                        self.disableButtons.submitButton = false;
                                        self.$router.push('/');
                                    }, 5000);
                                } else {
                                    $('#errorMsg').addClass('help is-danger');
                                    $('#errorMsg').show();
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                            })
                            .catch(function (err) {
                                self.buttonNames.submitButton = "Submit";
                                self.disableButtons.submitButton = false;
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').show();
                                    $('#errorMsg').html(err.response.data.message);
                                }
                            });
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login/UserForgotPassword.vue